import Circle from '@arcgis/core/geometry/Circle';

/**
 * Create an instance of the Circle and returns it
 * @param {Object} mapObject - map object
 * @param {Object} configs
 * @param {Object} configs.point - the coordinates to draw the marker
 * @param {Url} configs.icon - the svg icon used for the marker
 */
export const createCircleGeometry = async ({ mapObject, configs }) =>
  await handleCircleGeometry({ configs });

const handleCircleGeometry = ({ configs }) => {
  const circle = new Circle({
    ...configs,
  });
  return { circle };
};
